const ContentSecurityStates = {
  FLAGGED_FOR_REVIEW: 'FLAGGED_FOR_REVIEW',
  SECURITY_VIOLATION: 'SECURITY_VIOLATION',
  CLEAR: 'CLEAR',
  NONE: 'NONE'
};
export const VIOLATION_STATES = [ContentSecurityStates.FLAGGED_FOR_REVIEW, ContentSecurityStates.SECURITY_VIOLATION];
export default ContentSecurityStates;